var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98464 7L5.48464 10.5L4.66797 9.68333L7.3513 7L4.66797 4.31667L5.48464 3.5L8.98464 7Z",
    fill: "#5441D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPage);
export default __webpack_public_path__ + "static/media/next-page.365c63f5e033e558853644932c8abe91.svg";
export { ForwardRef as ReactComponent };